/* eslint-disable max-lines */

// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import handler from '../../../share/util/apiResultValidator';
import api from '../../../common/api';
import config from '../../../share/config';
import alert from '../../../share/alert';
import vehicle from '../../../share/util/vehicle';
import cstmTable from '../../../share/components/vue/PaginationTable';
import loading from '../../../share/components/vue/ProcessingIcon';
import logwrapper from '../../../share/logWrapper';
import resource from '../../../share/util/resourceMap';
import Error from '../../../common/nodejs/errors';
import pfcs from '../../../share/util/pfcs';
import util from '../../../share/util/utils';
import lngSwitch from '../../../share/util/languageSwitching';
const publishedUnitListTestMode = require('../../../data/testMode/publishedUnits.json');

export default {
  data() {
    return {
      showModalUsb: false,
      processing: false,
      units: [],
      serviceNewsUrl: '',
      translations: [],
      details: '',
      notes: '',
      systemTableColumns: [
        { name: 'name', label: 'message.header_vehicle_table_system_name', minWidth: '130px' },
        { name: 'target_parts_number', label: 'message.label_vehicle_system_target_parts_number' },
        { name: 'new_parts_number', label: 'message.label_vehicle_system_new_parts_number' },
        { name: 'target_romid', label: 'message.label_vehicle_system_target_romid', minWidth: '100px' },
        { name: 'new_romid', label: 'message.label_vehicle_system_new_romid', minWidth: '100px' }
      ],
      targetUnitDetails: [],
      selectedLanguage: '',
      translationLangs: [],
      serviceNewsList: [],
      isCCU: false,
      filePath: '',
      fileUrl: null,
      sessionKeepInterval: null,
      reproType: '',
      CombinedServiceNewsText: '',
      merchantabilityOrRestore: false,
      completionCheckServiceNews: false,
      targetSwidConsent: null,
      pfcFileName: '',

      nextPaneBg: '',        // 背景色設定
      nextMessage: '',        // 文言設定
      executeStartBtn: false,  //リプロ実行ボタン設定
      isSu: false,
      isShowSwidConsentBtn: false // ソフトウェア更新の承諾ボタン表示有無
    };
  },


  watch: {
    // 言語情報の変更を監視 
    displayLang() {
      this.updateTranslationList();
      this.computeTranslations();
    },
    // ユニット情報を監視 
    unitInfo() {
      this.updateUnitInfo();
    },

    language: {
      immediate: true,
      handler(val) {
        val; // To avoid warning
        const targetUnitDetailsTemp = [...this.targetUnitDetails];
        this.targetUnitDetails = this.putSystemName(targetUnitDetailsTemp);
      }
    },

    // USB Storageの読み取り状態監視 
    async pairingUsbStatus(value) {
      // 失敗
      if (value === config.POLLING_FAILURE) {
        this.processing = false;
        const error = this.pairingUsbError;
        // APIバリデータの戻りを確認
        if (error.validatorResult) {
          // ネットワーク接続エラーとセッション情報エラーは警告メッセージで表示する
          if (error.validatorResult.causeType === handler.causeTypes.networkError || error.validatorResult.causeType === handler.causeTypes.invalidSessionToken) {
            alert.showWarning(this, null, error.message, () => {
              if (error.behaviorType === handler.behaviorTypes.logout) {
                this.logout(this);
              } else if (error.behaviorType === handler.behaviorTypes.resetSession) {
                this.resetSession(this);
              }
            });
            return;
          }

          // ペアリングに失敗した場合はログアウト処理を実行しない 
          if (error.validatorResult.consoleCode === Error.DB_PAIRING_INFO_NOT_FOUND) {
            this.showFailedMessage('message.error_pairing_title', this.pairingUsbError, false);
          } else {
            // 警告以外のエラーメッセージの表示
            this.showFailedMessage('message.error_pairing_title', this.pairingUsbError);
          }
        } else {
          // バリデータ情報がない場合はエラーメッセージを表示する
          this.showFailedMessage('message.error_pairing_title', this.pairingUsbError);
        }
      }
      // 成功
      else if (value === config.POLLING_COMPLETED) {
        this.processing = false;
        // PFCファイル情報を取得
        this.processing = true;
        const endpoint = this.pairingAppId + '/' + this.unitInfo.unitId + '/' + 'reproTargets' + '/' + this.unitInfo.fileId;
        const res = await api.getCall(config.REPRO, '/netApps/' + endpoint);
        this.processing = false;

        handler.validate(handler.validateTypes.all, res, this, null, () => {
          // ユニット名を設定
          const unitName = this.targetUnitDetails[0] ? this.targetUnitDetails[0].name : '';
          // 新旧 SWID を設定
          const storages = res.data.storages;
          const newSwid = storages && storages.length > 0 ? storages[0].new_swid : '';
          const storageSwid = storages && storages.length > 0 ? storages[0].storage_swid : '';
          // FILE_TYPEを設定
          const pfcFileType = res.data.is_ccu ? config.PFC_FILE_TYPE_CCU : config.PFC_FILE_TYPE_DEFAULT;

          // USB照合情報を保持
          this.cacheCcuReproInfo({ systemId: this.unitInfo.unitId, systemName: unitName, newSwid: newSwid, usbSwid: storageSwid, fileType: pfcFileType });
          if (newSwid === storageSwid) {
            // 照合OKなので、attention画面を表示する
            // リプロ注意画面に遷移
            this.$router.push({ name: 'attention' });
          } else {
            // 照合NGなので、USB照合失敗画面を表示する
            this.$router.push({ name: 'usbVerificationFailed' });
          }
        }, (result) => {
          // ネットワークエラー・セッションエラーは警告を表示
          if (result.causeType === handler.causeTypes.networkError ||
            result.causeType === handler.causeTypes.invalidSessionToken) {
            alert.showWarning(this, null, result.message, () => {
              if (result.behaviorType === handler.behaviorTypes.logout) {
                this.logout(this);
              }
              else if (result.behaviorType === handler.behaviorTypes.resetSession) {
                this.resetSession(this);
              }
            });
          }
          else if (result.causeType === handler.causeTypes.clientConnectorNotAliveError) {
            // CC が起動していないなら強制サインアウト
            alert.showError(this, null, result.message, () => { this.logout(this); });
          }
          else {
            // その他のエラー
            alert.showError(this, null, result.message, () => {
              if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
              else if (result.behaviorType === handler.behaviorTypes.resetSession) this.resetSession(this);
            });
          }
        }, null, false);
      }
    },
  },

  components: {
    'cstm-table': cstmTable,
    'processing-view': loading,
  },

  computed: {
    ...mapState({
      // 車種情報取得の接続状況
      vehicleStatus: state => state.vehicle.status,
      vehicleWatcher: state => state.vehicle.watcher,
      displayLang: state => state.systems.language,
      unitInfo: state => state.targetUnit.unitInfo,
      pairingAppId: state => state.netAppConnector.pairingAppId,
      pairingUsbStatus: state => state.netAppConnector.usbStatus,
      pairingUsbError: state => state.netAppConnector.usbError,
      usbWatcher: state => state.netAppConnector.usbWatcher,
      region: state => state.userProperty.region,
      resources: state => state.masterResources.targetUnits,
      isTestMode: state => state.netAppConnector.isTestMode,
      masterTranslations: state => state.fileResources.translations,
      cachedTranslationLang: state => state.userProperty.userCache[config.USER_CACHE_REPRO_SYSTEM_TRANSLATION],
      paneConfig(state) {
        const cfg = state.targetUnit.unitInfo;
        const ret = cfg ? cfg.paneConfig : {};
        return ret;
      },
      language: state => state.systems.language,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      idsInfo: state => state.cache.systemIdsInfo,
      ccuReproInfo: state => state.cache.ccuReproInfo,
      intervalTime: state => state.auth.sessionKeepInterval,
      showDisplayVehicle: state => state.cache.showDisplayVehicle,
      testModeFileData: state => state.cache.testModeSelectFile,
      currentProvider: state => state.provider.currentProvider
    }),
    truncate: () => (value) => {
      const length = 140;
      const omission = "...";
      if (value.length <= length) {
        return value;
      }
      return value.substring(0, length) + omission;
    },
  },

  methods: {
    ...mapActions('app', ['setIsTimeoutLocked']),
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('vehicle', ['updateVehicleInfo']),
    ...mapActions('targetUnit', ['setUnitDetailInfo']),
    ...mapActions('targetUnit', ['setIsLongInterval']),
    ...mapActions('userProperty', ['setUserCache']),
    ...mapActions('cache', ['cacheSystemIdsInfo', 'cacheCcuReproInfo']),
    ...mapActions('netAppConnector', ['updatePairingStorageInquiryStatus']),
    ...mapActions('systems', ['extendSessionTimer']),

    // リプロ実行
    startRepro: function () {
      // 電圧取得の状態監視
      const watcherInstance = this.$watch('vehicleStatus', (val) => {
        // 画面遷移時の電圧取得失敗はエラーとしない。 
        if (val === config.POLLING_FAILURE || val === config.POLLING_COMPLETED) {
          watcherInstance();
          this.processing = false;

          // 対象ECUがCCUの場合
          if (this.isCCU) {
            // USB照合確認ダイアログを表示
            this.showModalUsb = true;
          } else {
            // リプロ注意画面に遷移
            this.$router.push({ name: 'attention' });
          }
        }
      });

      this.processing = true;
      // 電圧取得の開始 
      const data = {
        netAppId: this.pairingAppId,
        endPoint: '/vehicle/battery',
        this: this,
        type: config.REPRO
      };
      this.updateVehicleInfo(data);
    },

    // システムテーブル画面に戻る
    back: function () {
      // Vehicle 画面のヘッダタブを表示
      this.$router.push({ name: 'systemFileTable', params: { previousDisplayName: 'systemInformation' } });
    },

    // 翻訳言語選択リストを生成
    updateTranslationList: function () {
      // リスト初期化
      this.translationLangs = [];
      // リストを生成
      for (const i in this.translations) {
        this.translationLangs.push({
          text: lngSwitch.getLabel(this.masterTranslations, this.translations[i].language, this.displayLang),
          value: this.translations[i].language
        });
      }
    },

    // 表示言語ではなく、翻訳言語を参照して詳細・注意事項・サービスニュースを設定
    computeTranslations: function () {
      const translated = pfcs.buildTranslationDisplay(this.translations, this.selectedLanguage || 'en');
      const selected = translated.selectedTranslation;

      this.selectedLanguage = translated.selectedLanguage || 'en';
      this.serviceNewsUrl = translated.serviceNewsUrl;
      this.serviceNewsList = translated.serviceNewsList;

      this.details = selected ? selected.details : '';
      this.notes = selected ? selected.notes : '';

      if (this.isTestMode) {
        this.CombinedServiceNewsText = selected ? selected.service_news_name : '';
        return;
      }

      this.CombinedServiceNewsText = translated.serviceNewsText;
    },

    // Checks for repro is possible or not
    isReproPossible() {
      return this.unitInfo && this.unitInfo.fileId;
    },

    // 対象システム ID からシステム名称を取得
    putSystemName: function (tbl) {
      const targetUnitDisplayData = vehicle.getTargetUnitDisplayNames(this.resources, this.language);

      // Prepare count for each system id
      const idCountMap = {};
      for (const i in tbl) {
        const systemId = tbl[i].id;
        let systemDetails = idCountMap[systemId];
        if (!systemDetails) {
          systemDetails = {
            currentIndex: 1,
            count: tbl.filter(item => item.id === systemId).length,
            name: targetUnitDisplayData[systemId] || ''
          };
          idCountMap[systemId] = systemDetails;
        }

        tbl[i].name = systemDetails.count === 1 ? systemDetails.name : `${systemDetails.name} ${systemDetails.currentIndex}/${systemDetails.count}`;
        idCountMap[systemId].currentIndex += 1;
      }
      return tbl;
    },

    // 対象のユニット情報を更新する  
    async updateUnitInfo() {
      if (!this.isReproPossible()) {
        return;
      }

      // 警告ダイアログ表示が必要なシステムを判定
      if (this.paneConfig.showWarning) {
        // 前回表示画面がリプロ前注意画面、パスワード変更画面、単位設定画面以外なら警告を表示
        const previousName = util.getPreviousDisplayName(this.$route);
        let showWarning = true;
        if (previousName === 'attention' || util.isFromSettingsPage(previousName)) {
          showWarning = false;
        }
        if (showWarning) {
          const messages = this.$t(this.paneConfig.nextMessage);
          alert.showWarning(this, null, messages, () => { });
        }
      }

      // 詳細情報の取得
      let res = null;
      if (this.isTestMode) {
        const filteredList = publishedUnitListTestMode.filter(item => Number(item.id) === this.unitInfo.unitId);
        if (filteredList.length > 0) {
          const filteredItem = filteredList[0];
          res = {
            status: 200,
            data: {
              units: filteredItem.system_names.map((item, index) => {
                const filteredItemTemp = JSON.parse(JSON.stringify(filteredItem));
                if (filteredItem.system_names.length > 1) {
                  const startIndex = 2 * index;
                  filteredItemTemp.name = filteredItem.system_names[index].name || filteredItemTemp.name;
                  filteredItemTemp.id = filteredItem.system_names[index].id || filteredItem.id;
                  // Special handling for EYE
                  if (item.system_name === 'EYE_1' || item.system_name === 'EYE_2') {
                    filteredItemTemp.target_romid = index === 0 ? filteredItemTemp.target_romid.substr(0, 10) : filteredItemTemp.target_romid.substr(10);
                    filteredItemTemp.target_cid = null;
                    filteredItemTemp.target_swid = null;
                    filteredItemTemp.new_romid = index === 0 ? filteredItemTemp.new_romid.substr(0, 10) : filteredItemTemp.new_romid.substr(10);
                    filteredItemTemp.new_cid = null;
                    filteredItemTemp.new_swid = null;
                  } else {
                    filteredItemTemp.target_romid = filteredItemTemp.target_romid ? `${filteredItemTemp.target_romid.slice(0, -1)}${startIndex}` : null;
                    filteredItemTemp.target_cid = filteredItemTemp.target_cid ? `${filteredItemTemp.target_cid.slice(0, -1)}${startIndex}` : null;
                    filteredItemTemp.target_swid = filteredItemTemp.target_swid ? `${filteredItemTemp.target_swid.slice(0, -1)}${startIndex}` : null;
                    filteredItemTemp.new_romid = filteredItemTemp.new_romid ? `${filteredItemTemp.new_romid.slice(0, -1)}${startIndex + 1}` : null;
                    filteredItemTemp.new_cid = filteredItemTemp.new_cid ? `${filteredItemTemp.new_cid.slice(0, -1)}${startIndex + 1}` : null;
                    filteredItemTemp.new_swid = filteredItemTemp.new_swid ? `${filteredItemTemp.new_swid.slice(0, -1)}${startIndex + 1}` : null;
                  }
                  filteredItemTemp.target_parts_number = filteredItemTemp.target_parts_number ? `${filteredItemTemp.target_parts_number.slice(0, -1)}${startIndex}` : null;
                  filteredItemTemp.new_parts_number = filteredItemTemp.new_parts_number ? `${filteredItemTemp.new_parts_number.slice(0, -1)}${startIndex + 1}` : null;
                }
                return filteredItemTemp;
              }),
              repro_type: config.REPRO_TYPE_NORMAL,
              service_news_url: "",
              service_news_name: "",
              translations: [
                {
                  language: this.testModeFileData.language,
                  is_default: true,
                  details: this.testModeFileData.service_news_contents,
                  service_news_name: this.testModeFileData.service_news_no
                },
              ],
              file_name: "Test Mode PFC File"
            }
          };
        }
      } else {
        // ファイル ID が未設定の場合はリプロ対象外のデータであるため個別情報を取得しない。
        if (!this.unitInfo.fileId) return;
        this.processing = true;
        const endpoint = this.pairingAppId + '/' + this.unitInfo.unitId + '/' + 'reproTargets' + '/' + this.unitInfo.fileId;
        res = await api.getCall(config.REPRO, '/netApps/' + endpoint);
        this.processing = false;
      }

      handler.validate(
        handler.validateTypes.all, res, this, null, () => {
          const detailData = res.data;
          // リプロ種別の設定
          if (detailData.repro_type) {
            this.reproType = resource.getReproTypeResource(detailData.repro_type, 'msg');
            // Checks for repro type is MERCHANTABILITY or RESTORE
            this.merchantabilityOrRestore = this.reproType === "message.message_repro_type_merchantability" || this.reproType === "message.message_repro_type_restoration" ? true : false;
          }
          // SU法規PFCFile or 非SU法規PFCファイル
          this.isSu = detailData.is_su; // is_su_flowとは異なるフラグ
          // リプロ対象の詳細情報を設定
          this.setUnitDetailInfo(detailData.units);
          // PFCファイルのtargetIDを設定
          const targetIds = [];
          let isSpID = false;
          const isSwid = detailData.units && detailData.units.some((unit) => unit.target_swid);
          if (detailData.ids) {
            // リプロ対象がLCT_MAPかどうかを判定
            isSpID = detailData.ids.some((id) => id.id_type.toLowerCase() === "special_id");
            detailData.ids.forEach(item => {
              targetIds.push(item.target_id);
            });
          }
          this.cacheSystemIdsInfo({ ...this.idsInfo, "newIds": targetIds });
          // リプロ対象IDがSWIDの場合(CCU, DCM_Ethernet, LCT_G2 など)
          if (isSwid) {
            // 対象ユニットのヘッダ名を変更
            this.systemTableColumns[3].label = 'message.header_vehicle_system_target_swid';
            this.systemTableColumns[4].label = 'message.header_usb_verification_new_swid';
          }
          // リプロ対象がLCT_MAPの場合ヘッダ名を変更
          else if (isSpID) {
            this.systemTableColumns[3].label = 'message.header_vehicle_system_target_spid';
            this.systemTableColumns[4].label = 'message.label_vehicle_system_new_spid';
          }
          else {
            // 対象ユニットのヘッダ名を変更
            this.systemTableColumns[3].label = 'message.label_vehicle_system_target_romid';
            this.systemTableColumns[4].label = 'message.label_vehicle_system_new_romid';
          }
          // PFCファイルのファイル種別を設定
          this.isCCU = detailData.is_ccu;
          // 待機処理が長いシステムを判別
          this.setIsLongInterval(detailData.is_long_interval);
          // ファイル名を設定
          this.filePath = detailData.file_path;
          // PFCファイル名を設定
          this.pfcFileName = detailData.file_name;

          const targetUnitDetailsTemp = [];
          if (detailData.units) {
            detailData.units.forEach((unit) => {
              targetUnitDetailsTemp.push({
                id: unit.id,
                name: unit.name || null,
                target_parts_number: unit.target_parts_number,
                new_parts_number: unit.new_parts_number,
                target_romid: unit.target_romid || unit.target_cid || unit.target_special_id || unit.target_swid,
                new_romid: unit.new_romid || unit.new_cid || unit.new_swid || unit.new_special_id
              });
            });
          }
          this.targetUnitDetails = this.putSystemName(targetUnitDetailsTemp);
          this.translations = res.data.translations;
          this.updateTranslationList();

          if (this.translations.length > 0) {
            this.selectedLanguage = lngSwitch.extractSelectedLanguage(this.translations, this.cachedTranslationLang, this.displayLang);
          }

          this.computeTranslations();
        },
        (result) => {
          // ネットワークエラー・セッションエラーは警告を表示
          if (result.causeType === handler.causeTypes.networkError ||
            result.causeType === handler.causeTypes.invalidSessionToken) {
            alert.showWarning(this, null, result.message, () => {
              if (result.behaviorType === handler.behaviorTypes.logout) {
                this.logout(this);
              }
              else if (result.behaviorType === handler.behaviorTypes.resetSession) {
                this.resetSession(this);
              }
            });
          }
          else if (result.causeType === handler.causeTypes.clientConnectorNotAliveError) {
            // CC が起動していないなら強制サインアウト
            alert.showError(this, null, result.message,
              () => { this.logout(this); }
            );
          }
          else {
            // その他のエラー
            alert.showError(this, null, result.message, () => {
              if (result.behaviorType === handler.behaviorTypes.logout) {
                this.logout(this);
              }
              else if (result.behaviorType === handler.behaviorTypes.resetSession) {
                this.resetSession(this);
              }
            });
          }
        }, null, false);
    },

    // サービスニュース・詳細・注意事項の表示言語が変更されたときの処理
    updateLanguage: function (selected) {
      if (selected) {
        this.setUserCache({
          key: config.USER_CACHE_REPRO_SYSTEM_TRANSLATION,
          value: selected
        });
        this.selectedLanguage = selected;
        this.computeTranslations();
      }
    },

    // ccu reprogramming zip file downloadボタン表示判定処理
    isDownloadable: function () {
      return this.isCCU && this.filePath ? true : false;
    },

    // ccu reprogramming zip file download
    async downloadZip() {
      // zipダウンロード開始時にセッションタイマーを停止
      this.setIsTimeoutLocked(true);
      this.startSessionKeep();

      // zipファイルダウンロード先パスを初期化 
      this.fileUrl = null;
      this.processing = true;
      const params = {
        file_path: this.filePath
      };
      const response = await api.getParamCall(config.REPRO, '/downloadUrl', params);
      this.processing = false;

      handler.validate(
        handler.validateTypes.all,
        response, this, null,
        () => {
          // 処理が成功したときのコールバック処理
          this.fileUrl = response.data.fileUrl;
        },
        (result) => {
          // 処理が失敗したときのコールバック処理
          if (result.causeType === handler.causeTypes.invalidSessionToken) {
            alert.showWarning(this, null, result.message,
              () => {
                this.logout(this);
              });
          } else {
            alert.showError(this, null, result.message,
              () => {
                if (result.behaviorType === handler.behaviorTypes.logout) {
                  this.logout(this);
                } else if (result.behaviorType === handler.behaviorTypes.resetSession) {
                  this.resetSession(this);
                }
              });
          }
        }, null, false);
    },

    // 構成情報の書き換え後SWIDとZIPの書き換え後SWIDが一致するかの検証
    startVerificationUsb() {
      this.processing = true;
      this.updatePairingStorageInquiryStatus({
        netAppId: this.pairingAppId,
        instance: this
      });
      this.showModalUsb = false;
    },

    startSessionKeep: function () {
      this.sessionKeepInterval = this.$startInterval(() => {
        logwrapper.log('Get API version to prevent session timeout.');
        this.extendSessionTimer();
      }, this.intervalTime, 'CCU_Download_keep_session');
    },

    stopSessionKeep: function () {
      if (this.sessionKeepInterval) {
        this.$stopInterval(this.sessionKeepInterval);
        this.sessionKeepInterval = null;
      }
    },

    // エラーメッセージ表示処理 
    showFailedMessage(errTitleId, errorInfo, isLogout = true) {
      const error = errorInfo;
      // メンテナンスエラーの場合はエラー表示を変更する 
      let messages = null;
      if (!error.validatorResult || error.validatorResult.causeType === handler.causeTypes.maintenanceError) {
        messages = error.message;
      }
      else {
        const errTitle = this.$t(errTitleId);
        messages = {
          mainMessage: errTitle,
          messageList: []
        };
        const messageFirst = {
          label: this.$t('message.common_label_error_message'),
          message: error.message
        };
        messages.messageList.push(messageFirst);
      }

      alert.showError(this, null, messages, () => {
        if (error.behaviorType === handler.behaviorTypes.logout) {
          if (isLogout) {
            this.logout(this);
          }
        }
      });
    },
    addSwidConsent: async function () {

      if (!this.isTestMode) {
        this.processing = true;
        const endpoint = this.pairingAppId + '/' + this.unitInfo.unitId + '/swids' + '/consent/' + this.unitInfo.fileId;
        const response = await api.getCall(config.REPRO, '/netApps/' + endpoint);
        this.processing = false;
        if (typeof response.data === 'object' && response.data !== null) {
          if (response.data) {
            const swidConsent = response.data.consent_status;
            this.targetSwidConsent = swidConsent;
          }
        }
        this.executeStartBtn = this.targetSwidConsent === config.STATUS_UPDATE_CONSENT ? true : false;
        this.setSystemInfoDisplayColor();
      } else {
        this.targetSwidConsent = null;
      }
      if (this.targetSwidConsent !== undefined) {
        const emitData = {
          pfc_file_id: this.unitInfo.fileId,
          swid_consent: this.targetSwidConsent
        };
        this.$emit('updateTargetUnitData', emitData);
      }
    },
    // 許諾情報の更新
    async updateData(state) {
      await this.updateUnitInfo();
      this.targetSwidConsent = state;
      const emitData = {
        pfc_file_id: this.unitInfo.fileId,
        swid_consent: this.targetSwidConsent
      };
      await this.addSwidConsent();
      this.setSystemInfoDisplayColor();
      this.$emit('updateTargetUnitData', emitData);
    },
    // 許諾変更モーダル表示
    openConsentModal() {
      const emitData = {
        pfc_file_id: this.unitInfo.fileId,
        swid_consent: this.targetSwidConsent
      };
      this.$emit('openConsentModal', emitData);
    },
    // プログラム名称の表示
    getServiceNewsSeparator() {
      lngSwitch.getServiceNewsSeparator();
    },

    // 背景色の表示設定
    setSystemInfoDisplayColor() {
      // SU法規
      if (!this.paneConfig.nextMessage && this.vehicleInfo.vehicle.is_su_flow && this.isSu) {
        if (this.targetSwidConsent === config.STATUS_CONSENT_UNSETTED || this.targetSwidConsent === config.STATUS_UPDATE_REJECT) {
          this.nextPaneBg = 'pane-bgcolor-yellow';
          this.nextMessage = 'message.message_system_swid_not_consented';
        } else {
          this.nextPaneBg = '';
          this.nextMessage = '';
        }
      } else { // 非SU法規
        this.nextPaneBg = this.paneConfig.nextPaneBg;
        this.nextMessage = this.paneConfig.nextMessage;
      }
    }
  },

  beforeMount() {
    if (!this.isTestMode) {
      this.merchantabilityOrRestore = this.showDisplayVehicle === 'update' || this.showDisplayVehicle === 'restore';
    }
  },

  async mounted() {
    await this.updateUnitInfo();
    // SU法規の場合許諾情報を取得
    if (this.vehicleInfo.vehicle.is_su_flow && this.isSu) {
      await this.addSwidConsent();
      // SU法規対象PFCファイルの場合、ソフトウェア許諾ボタンを表示
      this.isShowSwidConsentBtn = true;
      this.executeStartBtn = this.targetSwidConsent === config.STATUS_UPDATE_CONSENT ? true : false;
    } else {
      this.isShowSwidConsentBtn = false;
      this.executeStartBtn = true;
    }
    this.setSystemInfoDisplayColor();
    //System画面へ遷移した場合にタブ表示・非表示を親に通知
    this.$emit('setVehicleTabsAvailable', false);
  },

  beforeUnmount() {
    this.$stopInterval(this.vehicleWatcher);
    this.$stopInterval(this.usbWatcher);
    this.setIsTimeoutLocked(false);
    this.stopSessionKeep();
  },

};